import type { Permission } from '@shared/infrastructure/auth/permission.js';

/** The slice of a route's meta this decision looks at. */
export interface PermissionMeta {
  permission?: Permission;
}

/**
 * Which permission a route asks for and the session does not hold.
 *
 * It walks the **whole matched chain**, not just the leaf: a child route is only
 * reachable through its parents, so a parent that asks for a permission asks for
 * it on behalf of everything under it. The first one missing is the one
 * reported, because that is the one to explain.
 *
 * `undefined` means the route is allowed — a route that declares no permission
 * needs none, which is how Inicio stays open to everyone with a session.
 */
export function missingPermissionFor(
  chain: readonly PermissionMeta[],
  can: (permission: Permission) => boolean,
): Permission | undefined {
  for (const meta of chain) {
    const required = meta.permission;

    if (required !== undefined && !can(required)) return required;
  }

  return undefined;
}
